import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Modal as BootstrapModal } from 'react-bootstrap'

const propTypes = {
  /**
   * If true, modal is shown.
   */
  show: PropTypes.bool,
  /**
   * Callback to hide the modal
   */
  onHide: PropTypes.func.isRequired,
  /**
   * Modal content/panels
   */
  children: PropTypes.node.isRequired,
  /**
   * Size of the modal
   */
  size: PropTypes.string,
  /**
   * If true, puts modal behind the backdrop, in case of another modal is opened on top of it for instance
   */
  toBackdrop: PropTypes.bool,
}

/**
 * Wrapper of the bootstrap modal for displaying it in as a sidebar
 */
function Modal(props) {
  const { show = false, onHide, children, size = 'md', toBackdrop = false } = props ?? {}

  return (
    <BootstrapModal
      backdrop
      size={size}
      show={show}
      onHide={onHide}
      className={clsx('right', {
        in: show,
        'modal-behind-backdrop': toBackdrop,
      })}
    >
      {children}
    </BootstrapModal>
  )
}

Modal.propTypes = propTypes

export default Modal
